
import React from 'react';
import Layout from '@/components/Layout';

const PricingPage: React.FC = () => {
  return (
    <Layout>
      <div className="container py-10">
        <h1 className="text-3xl font-bold">Pricing</h1>
        <p className="mt-4">View our pricing plans.</p>
      </div>
    </Layout>
  );
};

export default PricingPage;
